<!-- eslint-disable vue/html-indent -->
<template>
  <div class="fragment">

    <Head title="Dashboard" />

    <div class="w-full flex items-center justify-between mb-6">
      <h1 class="text-3xl text-gray-777 font-roboto">Dashboard</h1>
    </div>

  </div>
</template>
<script>

import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {

  },
  setup() {

  },
  data() {
    return {
    }
  },

  mounted() {

  },

  computed: {

  },

  methods: {

  },
}
</script>

<style scoped>

</style>
